import { createSoulodyClient } from '@/services/http/soulodyClient';

export const SoulodyClientVuexPlugin = store => {
  const client = createSoulodyClient({
    baseURL: import.meta.env.VITE_API_SOULODY_URL,
    ensureValidToken: () => store.dispatch('soulodyApi/ensureValidToken'),
    getAccessToken: () => store.state.soulodyApi.accessToken
  });

  store.$soulodyApi = client;
  store.dispatch('soulodyApi/initStore');
};
